module.exports = __webpack_public_path__ + "91d60d6666fd45f8ffc4d9f83bffc6d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-08-harrison-allepey/diary.jpg
// module id = 582
// module chunks = 0